export default "__VITE_ASSET__Z7vDJB43__"